import { Chip } from "@mui/material";
import { FC } from "react";

const StatusChipCell: FC<{
  isPending: boolean;
  label: string;
  isTest?: boolean;
  isSpecial?: boolean;
}> = ({ isPending, label, isTest, isSpecial }) => {
  if (isPending) {
    return <Chip label={"Pending"} sx={{ width: 1 }} />;
  }
  return (
    <Chip
      label={label}
      color={isTest ? "warning" : isSpecial ? "primary" : "success"}
      sx={{
        width: 1,
      }}
    />
  );
};

export default StatusChipCell;
